// extracted by mini-css-extract-plugin
module.exports = {"meal":"MealItem_meal__3o2X1","description":"MealItem_description__3xLeX","price":"MealItem_price__36hwG"};